import { useParams } from "react-router-dom";
import soluciones from "../../Data/soluciones.json";
import Seccion_Enfoque_Dinamico from "../Secciones/Seccion_Enfoque_Detalle";
import Seccion_Servicio_Enfoque from "./Seccion_Servicio_Enfoque";
import { Grid } from "@mui/material";

const Seccion_Servicio_Router = () => {
    const { categoria, servicio } = useParams();

    const slug = servicio
        ? `/servicios/${categoria}/${servicio}/`
        : `/servicios/${categoria}/`;

    const esPadre = soluciones.some(e => e.slug === slug);

    if (esPadre) return <Seccion_Enfoque_Dinamico />;

    return (
        <Grid container
              justifyContent="center"
              alignItems="center"
              size={{ xs: 12, sm: 12, md: 12 }}>
            <Seccion_Servicio_Enfoque />
        </Grid>
    );
};

export default Seccion_Servicio_Router;